/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  isValidStoredData.ts
 */

import { ExpirableLRUOptions } from '../types/ExpirableLRUOptions'
import { StoredData } from '../types/StoredData'

export const isValidStoredData = <TValue = any>(
  data: StoredData<TValue>,
  options: Pick<ExpirableLRUOptions<unknown, TValue>, 'ttl' | 'version'>
) => {
  const { ttl, version } = options
  const [, storedVersion, storedTTL, storedAt] = data
  const lifetime = Date.now() - storedAt
  return (
    lifetime < (storedTTL ?? ttl ?? Infinity) &&
    (version ?? true) === (storedVersion ?? true)
  )
}
